@use "foundation/_colors.scss";
@use "foundation/_responsive.scss";

.learn-more {
  margin-right: 1em;

  svg {
    width: 2em;
    height: 2em;
    margin-top: 3px;

    @include responsive.tablet {
      width: 1.5em;
      height: 1.5em;
      margin-top: 5px;
    }

    path {
      fill: colors.$primary-text-color;
    }
  }

  &.dark-header {
    svg {
      path {
        fill: white;
      }
    }
  }
}
